export default { sha: '592ab78c2ad187616d1c755308722f03d269f5fb', buildNumber: 'undefined' }
